import { render, staticRenderFns } from "./resourceMap.vue?vue&type=template&id=0a5846ca&scoped=true"
import script from "./resourceMap.vue?vue&type=script&lang=js"
export * from "./resourceMap.vue?vue&type=script&lang=js"
import style0 from "./resourceMap.vue?vue&type=style&index=0&id=0a5846ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5846ca",
  null
  
)

export default component.exports